import { camelizeKeys } from 'humps';

export default {
  createOrder(agreementResult, payPalPayload, userPayload, npi, deferredUserCreate) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: "/api/v1/paypal/create_order",
        type: "POST",
        data: {
          customer_info: {
            first_name: payPalPayload.first_name,
            last_name: payPalPayload.last_name,
            email: payPalPayload.email,
            phone: payPalPayload.phone
          },
          order: payPalPayload,

          // Only applicable for a flow that requires account creation.
          user: userPayload,

          // Only applicable for clinicians that enter an NPI value (registered clinician ID).
          npi,

          // If true, it means someone is purchasing on behalf of someone else (ex. organization owner), who will be sent an email and create an account later.
          deferred_user_create: deferredUserCreate,

          agreement_result: agreementResult
        },
        success: response => resolve(camelizeKeys(response)),
        error: response => reject(response)
      });
    });
  }
}